import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {UrlBuilder} from "../url-builder/url.builder";
import {MeasurementDataList} from "./MeasurementDataList";


@Injectable({
  providedIn: 'root'
})
export class MeasurementsDataService {
  private uiUrl: string = "";
  private url: UrlBuilder;

  constructor(private http: HttpClient) {
    this.url = new UrlBuilder();
  }

  GetData(): Observable<MeasurementDataList> {
    this.uiUrl = this.url.GetMeasurementDataUrl();
    console.log('FILE: ' + this.uiUrl);
    return this.http.get<MeasurementDataList>(this.uiUrl);
  }



}

